import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import SearchIcon from "@material-ui/icons/Search";
import { Paper, TextField, Button, Typography } from "@material-ui/core";
import { getToken } from "../../../auth/cognito/access";
import { NCapi } from "../../../api/axios/NCapi";
import PatientTable from "../../patient/components/PatientTable";
import ReloadButton from "../../../auth/components/ReloadButton";
import LoadingSpinner from "../../components/LoadingSpinner";
import { LastMonth } from "../../date/DateString";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function ICDSearchCard() {
  const classes = useStyles();
  let [s, e] = LastMonth();

  const [start, setStart] = useState(s);
  const [end, setEnd] = useState(e);
  const [icdCode, setIcdCode] = useState("E11%");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [list, setList] = useState([]);
  const [error, setError] = useState(Object());

  const handleChangeStart = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStart(event.target.value);
  };

  const handleChangeEnd = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEnd(event.target.value);
  };

  const handleChangeICD = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIcdCode(event.target.value);
  };

  const IcdSearch = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setIsLoading(true);

    getToken()
      .then((token) => {
        //alert('Token: ' + token)

        NCapi.defaults.headers.common["CognitoJWT"] = token;

        NCapi.post("patient/icd_search", {
          icdCode: icdCode,
          period: {
            start: start,
            end: end,
          },
        })
          .then((response) => {
            if (response.data.length < 1) {
              alert("The search returned no results.")
            }
            setList(response.data);
            setIsLoading(false);
          })
          .catch((error) => {
            setError(error);
            setIsError(true);
            setIsLoading(false);
            throw error;
          });
      })
      .catch((error) => {
        setError(error);
        setIsError(true);
        setIsLoading(false);
        throw error;
      });

    event.preventDefault();
  };

  if (isError) {
    return (
      <div>
        <Paper>
          <Typography variant="h2">
            ICD Search Error: {error.message}
          </Typography>
          <ReloadButton />
        </Paper>
      </div>
    );
  }

  if (list.length > 0) {
    return (
      <div>
        <PatientTable patients={list} />
      </div>
    );
  }

  return (
    <div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Card className={classes.root}>
          <CardContent>
            <CardHeader title="Search for Patients by ICD10" />
            <TextField
              placeholder="ICD10 Code"
              margin="normal"
              name="icdCode"
              label="ICD10 Code"
              helperText="Use % as a wildcard to search more broadly"
              value={icdCode}
              onChange={handleChangeICD}
            />
            <p></p>
            <TextField
              name="start"
              value={start}
              onChange={handleChangeStart}
              id="date"
              label="Encounter Date Start"
              type="date"
              defaultValue="2021-09-01"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              name="end"
              value={end}
              onChange={handleChangeEnd}
              id="date"
              label="Encounter Date End"
              type="date"
              defaultValue="2021-10-01"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </CardContent>
          <CardActions>
            <Button
              onClick={IcdSearch}
              color="primary"
              variant="contained"
              startIcon={<SearchIcon />}
            >
              Click to Search
            </Button>
          </CardActions>
        </Card>
      )}
    </div>
  );
}
